"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
function run($rootScope, $state, AUTH_EVENTS, AuthService, ENV, DrivesFilterService, UserService, CreateStudentService, FlashService, OpenReplayService, NavigationHistoryService) {
    angular_1.default.extend($rootScope, {
        center: {},
        markers: {},
        geojson: {},
        controls: {
            fullscreen: {
                position: "topleft",
            },
        },
    });
    loadThirdPartyScripts();
    loadUI();
    loadAuth();
    $rootScope.$on("$stateChangeStart", clearCalendarAndAgendaFilterParameters);
    $rootScope.$on("$stateChangeStart", clearCreateStudentService);
    function clearCalendarAndAgendaFilterParameters(event, toState, toParams, fromState, fromParams, options) {
        if (toState.name !== "drivecoach.admin.agenda" &&
            toState.name !== "drivecoach.admin.calendar" &&
            toState.name !== "drivecoach.admin.drives.edit" &&
            toState.name !== "drivecoach.admin.courses.edit" &&
            toState.name !== "drivecoach.admin.events.edit") {
            DrivesFilterService.clearFilterParameters();
        }
    }
    function clearCreateStudentService(event, toState, toParams, fromState, fromParams, options) {
        if (fromState.name === "drivecoach.admin.students.create") {
            CreateStudentService.clear();
        }
    }
    //
    // AUTH related things
    //
    function loadAuth() {
        $rootScope.$on("$stateChangeStart", guard);
        watchAuth();
    }
    function guard(event, next) {
        var allowedRoute = allowRoute(next);
        if (allowedRoute === false) {
            if (typeof next.data !== "undefined") {
                var authorizedRoles = next.data.authorizedRoles;
                AuthService.isAuthorized(authorizedRoles)
                    .then(function (response) { })
                    .catch(function (Error) {
                    event.preventDefault();
                    if (AuthService.isAuthenticated() === false) {
                        // user is not allowed
                        $rootScope.$broadcast(AUTH_EVENTS.notAuthorized);
                    }
                    else {
                        console.error(Error);
                        // user is not logged in
                        $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
                    }
                });
            }
        }
    }
    function watchAuth() {
        $rootScope.$on(AUTH_EVENTS.logoutSuccess, logout);
        $rootScope.$on(AUTH_EVENTS.notAuthorized, notAuthorized);
        $rootScope.$on(AUTH_EVENTS.notAuthenticated, function () {
            AuthService.goToLogin();
        });
        $rootScope.$on(AUTH_EVENTS.sessionTimeout, AuthService.goToLogin);
    }
    function notAuthorized() {
        FlashService.setMessage({
            type: "error",
            message: "You are not authorized to access this page.",
        });
        AuthService.goToLogin();
    }
    function isStaff(user) {
        return (user.role.type === "staff" ||
            user.role.type === "administrator" ||
            user.role.type === "owner");
    }
    function allowRoute(route) {
        var allowedRoute = route === "drivecoach.forgotpassword" ||
            route === "drivecoach.resetpassword" ||
            route === "drivecoach.signup.student" ||
            route === "drivecoach.signup.instructor" ||
            route === "drivecoach.signup.admin" ||
            route === "drivecoach.login";
        return allowedRoute === true;
    }
    //
    // UI related things
    //
    function loadUI() {
        NavigationHistoryService.init();
    }
    // Load Intercom
    function loadIntercom() {
        (function () {
            var w = window;
            var ic = w.Intercom;
            if (typeof ic === "function") {
                ic("reattach_activator");
                ic("update", window.intercomSettings);
            }
            else {
                var d_1 = document;
                var i_1 = function () {
                    i_1.c(arguments);
                };
                i_1.q = [];
                i_1.c = function (args) {
                    i_1.q.push(args);
                };
                w.Intercom = i_1;
                // @ts-expect-error Intercom
                function l() {
                    var s = d_1.createElement("script");
                    s.type = "text/javascript";
                    s.async = true;
                    s.src = "https://widget.intercom.io/widget/zyog25by";
                    var x = d_1.getElementsByTagName("script")[0];
                    x.parentNode.insertBefore(s, x);
                }
                // @ts-expect-error Intercom
                if (w.attachEvent) {
                    // @ts-expect-error Intercom
                    w.attachEvent("onload", l);
                }
                else {
                    w.addEventListener("load", l, false);
                }
            }
        })();
    }
    function loadThirdPartyScripts() {
        $rootScope.$on(AUTH_EVENTS.loginSuccess, loadIntercom);
        OpenReplayService.loadOpenReplay();
        loadIntercom();
        $rootScope.$on("$stateChangeSuccess", scrollToTop);
        if (ENV === "production") {
            // OpenReplayService.loadOpenReplay();
            $rootScope.$on("$stateChangeSuccess", setIntercomUser);
            $rootScope.$on("$stateChangeSuccess", setOpenReplayUser);
        }
    }
    function scrollToTop() {
        window.scrollTo(0, 0);
    }
    function setOpenReplayUser() {
        OpenReplayService.setUser(UserService.getCurrentUser());
    }
    // sets the current intercom user to match the logged in user
    function setIntercomUser() {
        if (AuthService.isAuthenticated() && ENV === "production") {
            if (typeof window.Intercom !== "function") {
                loadIntercom();
            }
            window.Intercom("boot", {
                app_id: "zyog25by",
            });
            if (isStaff(UserService.getCurrentUser())) {
                window.Intercom("update");
            }
        }
    }
    function logout() {
        $state.go("drivecoach.login");
    }
}
run.$inject = [
    "$rootScope",
    "$state",
    "AUTH_EVENTS",
    "AuthService",
    "ENV",
    "DrivesFilterService",
    "UserService",
    "CreateStudentService",
    "FlashService",
    "OpenReplayService",
    "NavigationHistoryService",
];
exports.default = run;
